<template>
  <div
    v-show="modalAudio"
    id="modalAudio"
    class="AudioCont ui-draggable ui-draggable-handle"
    :style="{width: widthAudioVideoModal}"
  >
    <div @click="cerrarAudio" class="AudioCont-cerrar"></div>
    <template v-if="srcAudio">

    </template>
    <template v-if="srcVideo">

    </template>
    <audio v-show="srcAudio" autoplay ref="playAudioModal" controls style="width: 150%;left:-55px;position:relative;transform: scale(0.54); height:40px">
        <source :src="srcAudio" type="audio/mp3">
    </audio>
    <video v-show="srcVideo" autoplay ref="playVideoModal" width="225" style="margin:10px" height="auto" controls>
        <source :src="srcVideo" type="video/mp4">
    </video>
  </div>
</template>

<script>
import $ from "jquery";
import { mapState } from 'vuex'

export default {
  name: "ModalAudio",

  data: () => ({}),
  methods: {
    cerrarAudio(){
        this.$refs.playAudioModal.pause();
        this.$refs.playVideoModal.pause();
        this.$store.state.srcVideo = null;
        this.$store.state.srcAudio = null;
        this.$store.state.modalAudio = false;
    },
  },
  updated: function(){
    if(this.$store.state.srcVideo == null){
      this.$refs.playAudioModal.load();
    }
    if(this.$store.state.srcAudio == null){
      this.$refs.playVideoModal.load(); 
    }
  },
  computed: {
    ...mapState(['literal','widthAudioVideoModal', 'srcVideo', 'srcAudio', 'modalAudio'])
  },
  mounted: function() {
    $(document).ready(() => {
      let top = ($(window).height() - $('#modalAudio').height()) / 2;
      let left = ($(window).width() - $('#modalAudio').width()) / 2;
      $('#modalAudio').css({'top': top + 'px', 'left':  left + 'px'})
    });

    let cronometro = document.getElementById('modalAudio');
    let viewer = document.getElementById('viewer');
    let seleccionado = false;
    let x = 0;
    let y = 0;
    let iniciar = this.literal["CRONOMETRO"]["INICIAR"];
    let detener = this.literal["CRONOMETRO"]["DETENER"];

    //Se Agrega los listener correpondiente a los movimientos que se hacen en el cronometro
    let agregarListener = () => {
      cronometro.addEventListener("mousedown", cronometrodown);
      cronometro.addEventListener("mousemove", cronometromove);
      cronometro.addEventListener("mouseup", cronometroup);
      cronometro.addEventListener("touchstart", cronometrotouch);
      cronometro.addEventListener("touchmove", cronometrotouchmove);
      cronometro.addEventListener("touchend", cronometrotouchend);
      // cronometro.addEventListener("touchstart", cronometrodown);
      // cronometro.addEventListener("touchmove", cronometromove);

      viewer.addEventListener("mousedown", cronometrodown);
      viewer.addEventListener("mousemove", cronometromove);
      viewer.addEventListener("mouseup", cronometroup);
      viewer.addEventListener("touchstart", cronometrotouch);
      viewer.addEventListener("touchmove", cronometrotouchmove);
      viewer.addEventListener("touchend", cronometrotouchend);
    };

    let cronometrodown = (e) => {
      if (e.target.id == 'modalAudio' || e.target.className == 'audioExample') {
        seleccionado = true;
        if(e.clientX && e.clientY) {
          x = e.clientX;
          y = e.clientY;
        } else {
          x = e.touches[0].clientX;
          y = e.touches[0].clientY;
        }
      } 
    }

    let cronometrotouch = (e) => {
      if (e.target.id == 'modalAudio' || e.target.className == 'audioExample') {
        seleccionado = true;
        x = e.changedTouches[0].pageX;
        y = e.changedTouches[0].pageY;
      } 
    }

    let cronometromove = (e) => {
      if (seleccionado) {
        if(e.clientX && e.clientY) {
          x = e.clientX - (x - $('#modalAudio').css('left').split('px')[0]);
          y = e.clientY - (y - $('#modalAudio').css('top').split('px')[0]);
        } else {
          x = e.touches[0].clientX - (x - $('#modalAudio').css('left').split('px')[0]);
          y = e.touches[0].clientY - (y - $('#modalAudio').css('top').split('px')[0]);
        }
        
        $('#modalAudio').css({'top': y + 'px', 'left': x + 'px'})

        if($('#modalAudio').css('left').split('px')[0] < 0) {
          $('#modalAudio').css({'top': y + 'px', 'left': 0.01 + 'px'})
        } 
        
        if ($(window).width() < parseInt($('#modalAudio').css('left').split('px')[0]) + $('#modalAudio').width()) {
          $('#modalAudio').css({'top': y + 'px', 'left': $(window).width() - $('#modalAudio').width() + 'px'})
        } 

        if($('#modalAudio').css('top').split('px')[0] < 56) {
          $('#modalAudio').css({'top': 100 + 'px', 'left': x + 'px'})
        } 

        if ($(window).height() - 56 < parseInt($('#modalAudio').css('top').split('px')[0]) + $('#modalAudio').height()) {
          $('#modalAudio').css({'top': $(window).height() - $('#modalAudio').height() - 100 + 'px', 'left': x + 'px'})
        }

        x = e.clientX;
        y = e.clientY;
      }
    }

    let cronometrotouchmove = (e) => {
      if (seleccionado) {
        x = e.changedTouches[0].pageX - (x - $('#modalAudio').css('left').split('px')[0]);
          y = e.changedTouches[0].pageY - (y - $('#modalAudio').css('top').split('px')[0]);
        
        $('#modalAudio').css({'top': y + 'px', 'left': x + 'px'})

        if($('#modalAudio').css('left').split('px')[0] < 0) {
          $('#modalAudio').css({'top': y + 'px', 'left': 0.01 + 'px'})
        } 
        
        if ($(window).width() < parseInt($('#modalAudio').css('left').split('px')[0]) + $('#modalAudio').width()) {
          $('#modalAudio').css({'top': y + 'px', 'left': $(window).width() - $('#modalAudio').width() + 'px'})
        } 

        if($('#modalAudio').css('top').split('px')[0] < 56) {
          $('#modalAudio').css({'top': 100 + 'px', 'left': x + 'px'})
        } 

        if ($(window).height() - 56 < parseInt($('#modalAudio').css('top').split('px')[0]) + $('#modalAudio').height()) {
          $('#modalAudio').css({'top': $(window).height() - $('#modalAudio').height() - 100 + 'px', 'left': x + 'px'})
        }

        x = e.changedTouches[0].pageX;
        y = e.changedTouches[0].pageY;
      }
    }

    let cronometroup = () => {
      if (seleccionado == true){
        seleccionado = false;
      }
    }

    let cronometrotouchend = () => {
      if (seleccionado == true){
        seleccionado = false;
      }
    }

    agregarListener();
     
    }
};
</script>

<style>
/********** CONT CRONO */

.AudioCont {
  /* display:none; */
  background-color: #3c3c3b;
  border: 2px solid black;
  width: 320px;
  height: auto;
  border-radius: 20px;
  position: absolute;
  left: 810px;
  top: 350px;
  z-index: 3;
  transform: scale(1.3);
}
.audioExample {
  width: auto;
  position: relative;
  margin: 5px auto 0px;
}
.centradoCrono {
  position: relative;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: no-wrap;
}
.startButtonCrono, .pauseButtonCrono, .resetButtonCrono {
  padding:4px 6px;
  border-radius: 10px;
  background-color: white;
  color: #fff;
  font-family: 'Open Sans';
  cursor: pointer;
  width: 100%;
  font-size: 90%;
  text-align: center;
  margin: 5px 6px;
  padding: 6px 12px;
  text-align: center;
}

.valuesCrono{
  text-align: center;
  font-size: 100%;
  padding: 5px 0;
  background-color: #adadad;
  border-radius: 10px;
  margin-top: -10px;
  margin-bottom: 10%;
  font-weight: bold;
   color: #3c3c3b
}
.startCrono{
  color: gray
}
.resetCrono{
 color: gray
}

.cropper-container {
  z-index: 1;
}

/* .modalPage_btn-cerrar, */
.AudioCont-cerrar,
.addLinkBtnCont-cerrar {
  width: 25px;
  height: 25px;
  background-size: 25px 25px;
  background-image: url('../../assets/img/equis.png');
  display: block;
  position: absolute;
  cursor: pointer;
  z-index: 9;
  right: -8px;
  top: -8px;
  transition: all .1s ease-in;
}

/* .modalPage_btn-cerrar:hover, */
.AudioCont-cerrar:hover,
.addLinkBtnCont-cerrar:hover {
  transform: scale(1.1)
}
</style>
